export function isProductVariantFeatureEnabled(hostname?: string | null): boolean {
  return true;
}
